import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Select, message, Checkbox, DatePicker } from 'antd';
import { Colors } from '../../helpers/Colors';
import { get_site_listing } from '../../Services/employee';
import CustomDropDownAutoComplete from '../AntD/DropDown';
import { gellAllLocomotiveLocations, getAllStatus, updateEquipmentById, updateEquipmentLocation, updateEquipmentStatus, updateFraStatus, updateLocomotive } from '../../Services/LocomotiveServices';
import dayjs from 'dayjs';
import moment from 'moment';
import roleManager from '../roles';
import { seriliazeParams } from '../../helpers/seriliazeParams';



const LocmotiveLookupModal = ({ setRefresh, open, close, data = { label: { name: "Null", values: {} } } }) => {

    const [form] = Form.useForm()
    const [Location, setLocation] = useState([])
    const [Status, setStatus] = useState([])
    const [backDateStatus, setBackDateStatus] = useState(false)
    const [canSubmit, setCanSubmit] = useState(true)

    const [FraStatus, setFraStatus] = useState([
        {
            label: "YES",
            value: "YES"
        },
        {
            label: "NO",
            value: "NO"
        }
    ])

    const getSiteLocation = async () => {
        let params = '?'.concat(seriliazeParams({
            locationType: 'LOC,ALL'
        }))
        const result = await gellAllLocomotiveLocations({ params })
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.title,
                    value: item?.id
                }
            })
            setLocation(data)

        }
    }
    const getAllStatuss = async () => {
        const result = await getAllStatus()
        if (result?.httpStatus === 200) {

            const data = result?.data.map((item, index) => {
                return {
                    label: item?.IS_Description,
                    value: item?.id
                }
            })
            setStatus(data)
        }
    }
    const onChange = (value) => {
        // setSelectedName(value)
    };
    const onSearch = (value) => {
    };

    // Filter `option.label` match the user type `input`
    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())


    const handleSubmit = async (values) => {



        if (data?.label?.key === 'FRA') {
            const result = await updateFraStatus(data?.values?.id, values)
            if (result?.httpStatus == 200) {
                message.success('Updated Successfully!');
                close('lookup')
            }
        }
        if (data?.label?.key === 'ActJob') {
            const result = await updateFraStatus(data?.values?.id, { ActJob: +values?.ActJob })
            if (result?.httpStatus == 200) {
                message.success('Updated Successfully!');
                close('lookup')
            }
        }
        if (data?.label?.key === 'EquipUID') {
            const result = await updateEquipmentById(data?.values?.id, values)
            if (result?.httpStatus == 200) {
                message.success('Updated Successfully!');
                close('lookup')
            }
        }
        // The Name is basically the name of Location so we update equip Location Name here
        if (data?.label?.key === 'name') {
            let locationData = { EquipLocation: values?.name }
            const result = await updateEquipmentLocation(data?.values?.id, locationData)
            if (result?.httpStatus == 200) {
                message.success('Updated Successfully!');
                close('lookup')
            }

        }
        if (data?.label?.key === 'Loco_Model') {
            const result = await updateLocomotive(data?.values?.id, { Loco_Model: values?.Loco_Model });
            if (result?.httpStatus === 200) {
                message.success('Updated Successfully!');
                close('lookup');
            }
        }


        if (data?.label?.key === "Mfr_Year") {
            let response = await updateLocomotive(data?.values?.id, { Mfr_Year: values?.Mfr_Year })
            if (response?.httpStatus == 200) {
                message.success('Updated Successfully!');
                close('lookup')
            }
        }

        const isStatusPending = Boolean([8, 9, 10].includes(values?.status));
        if (isStatusPending) {
            Modal.confirm({
                // title:<span  style={{paddingTop:'25px'}}> 'Confirm Removal'</span>,

                title: <span className='updateModal' style={{
                    color: Colors.mainBlue,
                    fontWeight: "600",
                    marginBottom: "0px ",
                    marginTop: '-2px',
                    fontSize: "20px",
                    display: 'block', // Makes it a block element
                    width: '100%', // Set width to 100%
                    // background: 'white' 
                    padding: '10px'



                }}>Confirm Removal</span>,
                content: 'Are you sure you want to continue? This action will remove this equipment from the active roster',
                okText: 'Remove',
                okButtonProps: { style: { background: '#2863AD', color: 'white', marginBottom: '10px', marginRight: '10px!important' } },
                cancelButtonProps: { style: { color: '#2863AD', marginBottom: '10px', marginRight: '10px!important' } },

                bodyStyle: { // Add your parent class to the bodyStyle property
                    className: 'custom-parent-class',
                },
                onOk: async () => {
                    setCanSubmit(false)
                    Modal.confirm({

                        okButtonProps: { style: { background: '#2863AD', color: 'red', marginBottom: '10px', marginRight: '10px!important' } },
                        cancelButtonProps: { style: { color: '#2863AD', marginBottom: '10px', marginRight: '10px!important' } },

                        // title: 'Removal Comments',

                        title: <span className='updateModal' style={{
                            color: Colors.mainBlue,
                            fontWeight: "600",
                            marginBottom: "0px ",
                            marginTop: '-2px',
                            fontSize: "20px",
                            display: 'block', // Makes it a block element
                            width: '100%', // Set width to 100%
                            // background: 'white' 
                            padding: '10px'



                        }}>Removal Comments</span>,

                        icon: null,
                        content: (
                            <Form form={form}>
                                <Form.Item
                                    name="removalComment"
                                    rules={[{ required: true, message: 'Please enter your removal!' }]}
                                    style={{ padding: '20px' }}
                                >
                                    <Input.TextArea
                                        rows={4}
                                        placeholder="Enter your feedback here"
                                    />
                                </Form.Item>
                            </Form>
                        ),
                        onOk: async () => {

                            const removalComment = form.getFieldsValue('removalComment');
                            // const StatusData = { Feedback: removalComment };
                            const StatusData = { EquipStatus: values?.status, removalComment: removalComment?.removalComment };


                            const result = await updateEquipmentStatus(data?.values?.id, StatusData);
                            if (result?.httpStatus === 200) {
                                message.success('Updated Successfully!');
                                close('lookup');
                            }
                        },
                        onCancel: () => {
                            // close('lookup')
                            setCanSubmit(true)
                        },
                        okButtonProps: { style: { background: '#2863AD', color: 'white', marginRight: '10px' } },

                    });
                },

            });
        }
        if (data?.label?.key == 'status' && !isStatusPending) {

            const StatusData = { EquipStatus: values?.status, backDate: backDateStatus ? moment(values?.backDate)?.format("YYYY-MM-DD") : null };

            const apiResult = await updateEquipmentStatus(data?.values?.id, StatusData);
            if (apiResult?.httpStatus === 200) {
                message.success('Updated Successfully!');
                close('lookup');
                form.setFieldsValue({
                    'backDate': null
                })
                setBackDateStatus(false)
                setRefresh(prev => { return prev = !prev })
            }

        }
        if (data?.label?.key === 'accounting') {
            const result = await updateFraStatus(data?.values?.id, { ActJob: parseInt(Number(values?.accounting)) })
            if (result?.httpStatus == 200) {
                message.success('Updated Successfully!');
                close('lookup')
            }

        }
    }
    const validateInput = (rule, value, callback) => {

        if (data?.label?.key === 'EquipUID') {
            const pattern = /^[A-Za-z]+ \d+$/;
            if (pattern.test(value)) {
                callback(); // Validation succeeded
            } else {
                callback('Input must start with alphabets, have a space, and end with numbers.'); // Validation failed
            }
        }
        else {
            callback();
        }
    };

    useEffect(() => {
        getSiteLocation()
        getAllStatuss()
        setBackDateStatus(false)
        form.setFieldsValue("backDate", null)
    }, [])


    function isISO8601Format(dateString) {
        return moment(dateString, moment.ISO_8601, true).isValid();
    }

    useEffect(() => {
        form.setFieldsValue(
            {
                ...data?.values,
                // ...data?.values?.TGSLocation,
                "name": data?.values?.TGSLocation?.id,
                "accounting": data?.values?.ActJob,
                "status": data?.values?.status?.id,
                "Mfr_Year": data?.values?.Mfr_Year ? isISO8601Format(data?.values?.Mfr_Year) ? moment(data?.values?.Mfr_Year) : null : null,
                "Loco_Model": data?.values?.Loco_Model || "",

            }
        )
    }, [data])
    return (
        <>
            <Modal
                open={open}
                onCancel={() => {
                    close('lookup');
                    setBackDateStatus(false);
                    form.setFieldsValue({ "backDate": null })
                }}
                footer={null}
                title={<p style={{ color: Colors.mainBlue, fontWeight: "600", marginBottom: "0px ", fontSize: "20px" }}>Update {data?.label?.name}</p>}
            >
                <Form
                    name='Locomotive Form'
                    onFinish={handleSubmit}
                    form={form}
                >
                    {
                        data?.values &&
                        <>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: "10px" }}>
                                <p style={{ width: "150px", fontSize: "16px", fontWeight: "700", whiteSpace: "nowrap", marginBottom: "0px" }}>{["Mfr_Year"]?.includes(data?.label?.key) ? "Enter" : ""} {data?.label?.name}</p>
                                {['FRA', 'name', 'status'].includes(data?.label?.key) ?
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Form.Item name={data?.label?.key} rules={[{ required: true, message: "Kindly enter value" }]} style={{ margin: "0px" }}>
                                            <Select style={{ width: "350px" }}
                                                showSearch
                                                optionFilterProp="children"
                                                onChange={onChange}
                                                onSearch={onSearch}
                                                filterOption={filterOption}
                                                options={data?.label?.key === "status" ? Status : data?.label?.key === "name" ? Location : FraStatus}
                                            />
                                        </Form.Item>
                                        {roleManager("custom_conditions", "system_loco_admin") && data?.label?.key === "status" ?
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <Checkbox checked={backDateStatus} onChange={(e) => {
                                                    if (!e) form.setFieldsValue("backDate", null)
                                                    setBackDateStatus(e.target.checked)
                                                }}>Back date status change</Checkbox>
                                                <Form.Item
                                                    name={"backDate"}
                                                    rules={[
                                                        {
                                                            required: backDateStatus,
                                                            message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                                                        },
                                                    ]}>
                                                    <DatePicker disabled={!backDateStatus} disabledDate={(current) => current.isAfter(moment())} />
                                                </Form.Item>
                                            </div> : <></>}
                                    </div>
                                    : ["Mfr_Year"]?.includes(data?.label?.key) ?
                                        <Form.Item name={data?.label?.key} rules={[{ required: true, message: "Kindly enter value" }]} style={{ margin: "0px" }}>
                                            <DatePicker picker='year' disabledDate={current => current && current > moment().endOf('year')} />
                                        </Form.Item>
                                        : <Form.Item
                                            name={data?.label?.key}
                                            rules={[
                                                { required: true, message: `${data?.label?.name} is required` },
                                                { validator: validateInput, message: "Format not valid!" },
                                            ]}
                                            style={{ margin: "0px" }}
                                        >
                                            {data?.label?.key !== 'ActJob' ? (
                                                <Input
                                                    type="Text"
                                                    placeholder={`Enter ${data?.label?.key}`}
                                                    readOnly={false}
                                                    style={{
                                                        background: 'white',
                                                        fontSize: "12px",
                                                        width: "300px",
                                                    }}
                                                />
                                            ) : (
                                                <Input
                                                    type="Number"
                                                    placeholder={`Enter ${data?.label?.key}`}
                                                    readOnly={false}
                                                    style={{
                                                        background: 'white',
                                                        fontSize: "12px",
                                                        width: "300px",
                                                    }}
                                                />
                                            )}
                                        </Form.Item>


                                }


                            </div>
                            {
                                data?.label?.key === 'EquipUID' &&
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                                    <p style={{ width: "150px", fontSize: "16px", fontWeight: "700", whiteSpace: "nowrap", marginBottom: "0px" }}>Notes</p>
                                    <Form.Item name={'RestencilNotes'} rules={[{ required: false, }]} style={{ margin: "0px" }}>
                                        <Input type={'Text'} placeholder='Enter value' readOnly={false} style={{
                                            background: 'white',
                                            fontSize: "12px",
                                            width: "300px"
                                        }} />
                                    </Form.Item>
                                </div>
                            }

                            <div style={{ display: "flex", justifyContent: "end", }} >
                                {canSubmit ?
                                    <Button htmlType='submit' style={{ background: Colors.mainBlue, color: "white", border: "none", marginTop: "30px" }}>Update</Button>
                                    : <></>
                                }
                            </div>
                        </>
                    }
                </Form>

            </Modal>
        </>
    );
};
export default LocmotiveLookupModal;